import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { ProductResultDto } from 'src/dtos/productResult/ProductResultDto';
import { getData } from 'src/utils/axios/serverHelper';

const baseUrl = `${config.apiUrl}/productResult`;

export interface ProductResultPopupSearchParams {
	compCd?: string;
	startDate?: string;
	endDate?: string;
	orderType?: string;
	workplaceCd?: string;
	itemCd?: string;
	productEmp?: string;
}

export const getProductResultPopupList = async (
	searchText: string,
	filters: ProductResultPopupSearchParams = {},
) => getData<ResponseDto<ProductResultDto[]>>(`${baseUrl}/modal`, {
	params: {
		searchText: searchText || '',
		compCd: filters.compCd || '',
		startDate: filters.startDate || '',
		endDate: filters.endDate || '',
		orderType: filters.orderType || '',
		workplaceCd: filters.workplaceCd || '',
		itemCd: filters.itemCd || '',
		productEmp: filters.productEmp || '',
	},
});
